<template>
  <div>
    <div class="page-header">
      <div class="container">
        <div class="course-badges">
          <slot v-if="isLoaded">
            <div class="badge" v-for="(badge, $index) in course.badges" :key="$index"
                                     :style="`background-color: ${badge.color}`">
              <span>{{badge.name}}</span>
            </div>
          </slot>
          <skeleton-box v-else width="80px" height="20px"></skeleton-box>
        </div>
        <h3 class="page-header_title">
          <slot v-if="isLoaded">{{course.name}}</slot>
          <skeleton-box v-else width="270px" height="33px"></skeleton-box>
        </h3>
        <span class="page-header_description">
          <slot v-if="isLoaded">{{course.description}}</slot>
          <skeleton-box v-else width="130px" height="16px"></skeleton-box>
        </span>
      </div>
    </div>
    <div class="content">
      <router-link class="btn btn-default btn-back back-prof" to="/profile">
        <i class="fas fa-angle-left"></i> Profile
      </router-link>
      <ul class="round-items" v-if="isLoaded">
        <li v-for="(task, $index) in tasks" :key="$index"
            v-on:click="startTask(task.id)">
          <div class="round-item">
            <div class="round-items_value" v-if="!task.userData || !task.userData.endedDate"><span>{{task.level}}</span>
            </div>
            <div class="round-items_value active" v-else><span>{{task.level}}</span></div>
            <div class="round-items_text">
              <div class="item-title">{{task.name}}</div>
              <div class="item-description">{{task.description}}</div>
            </div>
          </div>
        </li>
      </ul>
      <ul v-else class="round-items skeleton-list">
        <li v-for="i in 2">
          <skeleton-box width="auto" height="80px" display="block" style="margin: 0.75rem 1rem;"></skeleton-box>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
    import {TASK_REQUEST} from "../store/actions/task";
    import task from "../store/modules/task";
    import {TaskFilter} from "../models/taskFilter";
    import {COURSE_REQUEST, GET_COURSE} from "../store/actions/course";
    import SkeletonBox from "../components/SkeletonBox";

    export default {
        name: "CourseMap",
        components: {SkeletonBox},
        props: ['id'],
        data() {
            return {
                course: {
                    name: '',
                    description: '',
                    badges: []
                },
                tasks: []
            }
        },
        created() {
            this.$store.dispatch(TASK_REQUEST, new TaskFilter({courseId: this.id}));

            this.prepareTasks(this.$store.getters.getTasks);

            if (this.$store.getters.getCourses.length === 0) {
                this.$store.dispatch(COURSE_REQUEST);
            }else {
                this.prepareCourse(this.$store.getters.getCourses);
            }
        },
        mounted() {
            this.$store.watch(
                (state, getters) => getters.getTasks,
                (tasks) => {
                    this.prepareTasks(tasks);
                },
            );

            this.$store.watch(
                (state, getters) => getters.getCourses,
                (courses) => {
                    this.prepareCourse(courses);
                },
            );
        },
        methods: {
            prepareTasks(tasks) {
                this.tasks = tasks.filter(x => x.courseId === this.id);
            },
            prepareCourse(courses) {
                this.course = courses.find(course => course.id === this.id);
            },
            startTask(id) {
                this.$router.push({
                    name: 'TaskTheory',
                    params: {
                        courseId: this.id,
                        id: id
                    }
                });
            }
        },
        computed: {
            isLoaded() {
                return this.tasks.length !== 0;
            }
        }
    }
</script>

<style scoped>

</style>
